import React from "react";
import Image from "next/image";
import { logisticsData } from "@/data/logistics";
export default function Logistics() {
  return (
    <div className="grid md:grid-cols-3 grid-cols-1 auto-rows-auto lg:gap-12 md:gap-4 gap-4 lg:mb-20 mb-12">
      {logisticsData?.map((row, key) => (
        <div
          className="flex lg:flex-row flex-col lg:items-center gap-4 shadow-artist p-4 rounded-2xl border-[1px] border-grey-200"
          key={"logistic" + key}
        >
          <div className="relative md:h-[60px] md:w-[60px] h-[50px] w-[50px] shrink-0 rounded">
            <Image
              src={row?.icon}
              alt={row?.title}
              fill
              className="object-cover object-left w-full rounded-lg p-2"
              sizes="(max-width: 479px) 479px,(max-width: 768px) 768px, (max-width: 1200px) 1200px,(max-width: 1920px) 1920px, 1000px"
            />
          </div>
          <div className="flex flex-col items-start justify-start gap-1">
            <p className="text-blue font-medium">{row?.title}</p>
            <div
              className="md:text-base text-sm !leading-tight"
              dangerouslySetInnerHTML={{
                __html: `${row?.description}`,
              }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
